<template>
  <div data-testid="overview-tab">
    <TextWithImageGridSection
      :images="intro.images"
      container-image-classes="xl:w-full md:justify-end xl:gap-x-4"
      expand-images
    >
      <div
        class="flex w-full flex-col gap-y-3 pb-4 xl:pb-0"
        data-testid="banner-descriptions"
      >
        <h3 data-testid="banner-title" class="text-xl font-bold">
          {{ intro.title }}
        </h3>

        <div class="flex w-full flex-col gap-y-3 text-base">
          <p v-for="(paragraph, index) in intro.body" :key="index">
            {{ paragraph }}
          </p>
        </div>

        <div class="flex gap-2">
          <div class="h-6 border-l-4 border-l-p-500" />
          <div class="text-lg font-semibold">
            Sustainability Index - Top 5 Companies
          </div>
        </div>
        <SustainabilityIndexIntro :market="market" />
        <ButtonContactUs
          :services="initialFields"
          text="Contact Us"
          class="mt-1 px-[31.07px] py-[21px] text-sm"
        />
      </div>
    </TextWithImageGridSection>

    <div
      v-if="services.length > 0"
      class="mx-auto max-w-content-container"
      data-testid="package-section"
    >
      <div data-testid="package-title" class="mb-6 text-lg font-semibold">
        {{ title }}
      </div>

      <div
        class="mb-5 grid grid-cols-1 gap-3 lg:grid-cols-3"
        data-testid="package-cards"
      >
        <Package
          v-for="(service, index) in services"
          :key="index"
          :service="service"
          class="min-h-[112px] bg-white shadow-pm lg:shadow-none"
          data-testid="package-cards-items"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TextWithImageGridSection from '~/components/shared/common/TextWithImageGridSection.vue'
import SustainabilityIndexIntro from '~/components/sustainability/SustainabilityIndexIntro.vue'
import Package from '~/components/shared/services/Package.vue'
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'
import type { TMarketServiceConfig } from '~/src/types/markets'

type TImage = {
  url: string
  alt: string
}

type TIntro = {
  title: string
  body: string[]
  images: {
    one: TImage
    two: TImage
    three: TImage
  }
}

type TService = {
  icon: string
  description: string
}

type TProps = {
  market: TMarketServiceConfig
  title: string
  intro: TIntro
  initialFields?: [] | object
  services?: TService[]
}

withDefaults(defineProps<TProps>(), {
  initialFields: () => [],
  services: () => [],
})
</script>
